import { type QueryClient } from '@tanstack/react-query';

import { FetchGetOffersByPinLoadService } from '@/packages/query-state/shared/store/search-offers/v1/get-offers-by-pin/load';
import { FetchSearchOffersDesktopLoadService } from '@/packages/query-state/shared/store/search-offers/v3/search-offers-desktop/load';

import { type IOfferAnalyticsSchema } from '@/repositories/generated/shared/search-offers/entities/analytics/OfferAnalyticsSchema';
import { type IOfferForDesktopEnrichedV3Schema } from '@/repositories/generated/shared/search-offers/entities/offer_for_desktop/OfferForDesktopEnrichedV3Schema';

type GetAnalyticsProductParams = {
  offer: IOfferForDesktopEnrichedV3Schema;
};

export type AnalyticsProduct = IOfferAnalyticsSchema['product'];
export type AnalyticsProducts = Array<AnalyticsProduct>;

export function getAnalyticsProduct(params: GetAnalyticsProductParams): AnalyticsProduct {
  const { offer } = params;

  return offer.analytics.product;
}

type GetAnalyticsProductsParams = {
  queryClient: QueryClient;
  activePinId?: string;
  searchOffersQueryKey: string[];
};

export function getAnalyticsProducts(params: GetAnalyticsProductsParams): AnalyticsProduct[] {
  const { queryClient, activePinId, searchOffersQueryKey } = params;

  const offers = activePinId ? getOffersByPin(queryClient, activePinId) : getOffers(queryClient, searchOffersQueryKey);

  return offers.map(offer => getAnalyticsProduct({ offer }));
}

function getOffersByPin(queryClient: QueryClient, activePinId: string): IOfferForDesktopEnrichedV3Schema[] {
  const data = new FetchGetOffersByPinLoadService(queryClient).getQueryData(activePinId);

  return data?.offers || [];
}

function getOffers(queryClient: QueryClient, queryKey: string[]): IOfferForDesktopEnrichedV3Schema[] {
  const data = new FetchSearchOffersDesktopLoadService(queryClient, queryKey).getQueryData();

  return data?.pages[data.pages.length - 1].offers || [];
}
